module.exports = __webpack_public_path__ + "img/humanresources.3a334f55.svg";